<template>
  <div>
    <StoreSelector></StoreSelector>
  </div>
</template>

<script>
import StoreSelector from '../store-selector/StoreSelector';

export default {
  name: 'ProductStoreSelector',
  components: {
    StoreSelector,
  },
};
</script>

